import React from 'react';
import { useTranslation } from 'react-i18next';

import type { QuickSizeFilterOption } from '@r6digital/rapidstor-types/react/entities/Journey';
import useRapidStorTracking from '@/core/hooks/useRapidStorTracking';

import { ALL_QUICK_SIZE_KEY } from '../../../filters';

import classes from './styles.module.scss';

interface QuickSizeFilterProps {
    options: QuickSizeFilterOption[];
    /** The selected option key, or `ALL_QUICK_SIZE_KEY`. */
    value: string;
    onChange: (key: string) => void;
}

function QuickSizeFilter({
    options,
    value,
    onChange,
}: QuickSizeFilterProps) {
    const { t } = useTranslation();
    const { trackEvent } = useRapidStorTracking();

    const buttons = [
        { key: ALL_QUICK_SIZE_KEY, label: t('standardUnitListing:all') },
        ...options.map((o) => ({ key: o.key, label: t(o.label, { defaultValue: o.label }) })),
    ];

    return (
        <div
            className={classes.wrapper}
            role="radiogroup"
            aria-label="Quick Search"
        >
            <span className={classes.label}>
                {t('standardUnitListing:quickSearch')}
            </span>
            <div className={classes.options}>
                {buttons.map((b) => (
                    <button
                        key={b.key}
                        type="button"
                        role="radio"
                        aria-checked={value === b.key}
                        className={value === b.key ? classes.active : classes.inactive}
                        onClick={() => {
                            onChange(b.key);
                            trackEvent('size_filter_clicked', {
                                filter: b.key,
                            });
                        }}
                    >
                        {b.label}
                    </button>
                ))}
            </div>
        </div>
    );
}

export default QuickSizeFilter;
